module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-61.21c79cab.svg";